export const modeloVeicularFilterConfig = [
  {
    id: 'search',
    type: 'text',
    label: 'Descrição',
    placeholder: 'Digite a descrição do modelo'
  }
];
